import React from "react"
import { Helmet } from "react-helmet"
import { Lang } from "../const"

const FarsiHeader = () => {
    return (
        <div>
            <Helmet>
            <script type="text/javascript" src="/public/js/responsive.js"></script>
                <script async src="https://www.googletagmanager.com/gtag/js?id=UA-133712275-1"></script>
                <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link href="https://fonts.googleapis.com/css?family=Roboto:400,900" rel="stylesheet" />
                <link rel="stylesheet" type="text/css" href="/css/style.css" />
                <link rel="stylesheet" type="text/css" href="/css/stylefa.css" />
                <link rel="stylesheet" type="text/css" href="/css/media_query.css" />
                <title>یادگیری مکالمه ی زبان گرجی، فقط در 5 روز</title>
                <meta
                    name="description"
                    content="با درس های صوتی رایگان ما، 101 واژه ی کلیدی زبان گرجی را برای مکالمه یاد بگیرید... فقط در 5 روز و کاملا تضمین شده!هر درس حدود 30 دقیقه است. برای دریافت رایگان نسخه ی فارسی این دوره، این سایت را ببینید."
                />
                <meta
                    name="keywords"
                    content="گرجی, گرجستان, آموزش, زبان, گرجی, مکالمه, دیالوگ, کلمات, اصطلاحات, تفلیس, ایران, ایرانیان, فارسی, فارسی زبان, به فارسی, خواندن, نوشتن, فهمیدن, سرمایه گذاری در گرجستان, اقامت در گرجستان"
                />
            </Helmet>

            <div id="header">
                <a href="/fa">
                    <div id="logo"></div>
                </a>
                <div className="wrapper">
                    <div id="menu">
                        <ul>
                            <li>
                                <a href="/fa/free_lesson">آموزش رایگان</a>
                            </li>
                            <li>
                                <a href="/fa/#article-area">مقالات</a>
                            </li>
                            <li>
                                <a href="/fa/contact">ارتباط با ما</a>
                            </li>
                            <li>
                                <a href="/fa/aboutus">درباره ما</a>
                            </li>
                        </ul>
                    </div>
                    <div id="langSelection">
                        <a href="/fa" style={{ textDecoration: "none" }}>
                            فارسی
                        </a>{" "}
                        | <a href="/">English</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

const EnglishHeader = () => {
    return (
        <div>
            <Helmet>
            <script type="text/javascript" src="/public/js/responsive.js"></script>
                <script async src="https://www.googletagmanager.com/gtag/js?id=UA-133712275-1"></script>

                <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link rel="preconnect" href="https://fonts.gstatic.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" />
                <link
                    href="https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,400;0,900;1,400;1,900&family=Poppins:ital,wght@0,300;0,400;0,900;1,300;1,400;1,900&display=swap"
                    rel="stylesheet"
                />
                <link rel="stylesheet" type="text/css" href="/css/style.css" />
                <link rel="stylesheet" type="text/css" href="/css/media_query.css" />

                <title>Speak Georgian in 5 days, guaranteed!</title>
                <meta
                    name="description"
                    content="Free Audio Course Teaches 101 Essential Words of Georgian: Speak Georgian in 5 Days, Guaranteed.Each lesson is 30 minutes long. Get all of them for free by signing up at this site"
                />
                <meta
                    name="keywords"
                    content="Georgia, Georgian, Georgian language, Tbilisi, learn Georgian, speak Georgian, understand Georgian, read Georgian, write Georgian, language, English, conversation, dialogue"
                />
            </Helmet>

            <div id="header">
                <a href="/">
                    <div id="logo"></div>
                </a>
                <div className="wrapper">
                    <div id="menu">
                        <ul>
                            <li>
                                <a href="/free_lesson">Free Lessons</a>
                            </li>
                            <li className="disappear">
                                <a href="/purchase_course">Purchase Course</a>
                            </li>
                            <li className="disappear">
                                <a href="/members_area">Members Area</a>
                            </li>
                            <li>
                                <a href="/#article-area">Articles</a>
                            </li>
                            <li>
                                <a href="/contact">Contact</a>
                            </li>
                            <li>
                                <a href="/aboutus">About Us</a>
                            </li>
                        </ul>
                    </div>

                    <div id="langSelection">
                        <a href="/" style={{ textDecoration: "none" }}>
                            English
                        </a>{" "}
                        | <a href="/fa">فارسی</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

const Header = ({ lang }: { lang: Lang }) => {
    if (lang === "fa") return <FarsiHeader />
    else return <EnglishHeader />
}

export default Header